import { Image as ImageIcon } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { getFileUrl } from '@/clients/http'

interface UserImageSectionProps {
    imageUrl?: string
    mode: 'create' | 'edit' | 'view'
    onSelectClick: () => void
    onRemoveClick: () => void
}

export const UserImageSection = ({
    imageUrl,
    mode,
    onSelectClick,
    onRemoveClick,
}: UserImageSectionProps) => {
    return (
        <div className="flex justify-center">
            <div className="w-full max-w-48">
                <div className="flex min-h-40 flex-col items-center justify-center rounded-lg border border-dashed border-border bg-subdued p-4">
                    {imageUrl ? (
                        <div className="group relative aspect-square w-full overflow-hidden rounded-full">
                            <img
                                src={getFileUrl(imageUrl)}
                                alt="Profile"
                                className="size-full object-cover"
                            />

                            {mode !== 'view' && (
                                <div className="absolute inset-0 flex items-center justify-center gap-2 bg-ink/60 opacity-0 transition-opacity group-hover:opacity-100">
                                    <Button
                                        type="button"
                                        variant="secondary"
                                        size="sm"
                                        onClick={onSelectClick}>
                                        Change
                                    </Button>
                                    <Button
                                        type="button"
                                        variant="destructive"
                                        size="sm"
                                        onClick={onRemoveClick}>
                                        Remove
                                    </Button>
                                </div>
                            )}
                        </div>
                    ) : (
                        <div className="space-y-2 text-center">
                            <div className="inline-block rounded-full bg-fill p-3">
                                <ImageIcon className="size-6 text-muted-foreground" />
                            </div>
                            <div className="space-y-1">
                                <p className="text-sm text-text-2">No image</p>
                            </div>
                            {mode !== 'view' && (
                                <Button
                                    type="button"
                                    variant="outline"
                                    size="sm"
                                    onClick={onSelectClick}>
                                    Select image
                                </Button>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}
